import { create } from "zustand";
import produce from "immer";

export const useStoreTasksLocally = create((set) => ({
    tasks: [],
    setTasks: (new_tasks) => {
        set(
            produce((state) => {
                state.tasks = new_tasks;
            })
        );
    },
    setAddTasks: (new_tasks) => {
        set(
            produce((state) => {
                state.tasks = [...state.tasks, ...new_tasks];
            })
        );
    },
}));

export const useTasksLocally = () =>
    useStoreTasksLocally((state) => state.tasks);
export const useSetAddTasksLocally = () =>
    useStoreTasksLocally((state) => state.setAddTasks);
export const useSetTasksLocally = () =>
    useStoreTasksLocally((state) => state.setTasks);
